import { ImageDimensions } from "types/ReportingDashboard/elements.types"

export const getImageDimensions = (
  base64Src: string
): Promise<ImageDimensions> => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight })
    }
    img.onerror = (errEvt) => {
      const error =
        typeof errEvt === "string"
          ? new Error(errEvt)
          : errEvt instanceof ErrorEvent
          ? errEvt.error
          : new Error("Image loading failed")
      console.error(
        "Failed to load image for dimension calculation:",
        errEvt,
        "Processed error:",
        error
      )
      reject(error)
    }
    img.src = base64Src
  })
}
